export const CLEAR_ACTION = {
  labelText: 'Clear',
  eventId: 'clear-action',
};
export const SEARCH_ACTION = {
  labelText: 'Search',
  iconName: 'search',
  eventId: 'search-action',
};
export const SHOW_ACTION = {
  labelText: 'Show all',
  eventId: 'show-all-action',
};
export const VIEW_MESSAGE_ACTION = {
  labelText: 'View message',
  eventId: 'view-message-action',
};

export const ADD_MESSAGE_ACTION = {
  labelText: 'Add message',
  eventId: 'add-message-action',
};

export const DELETE_VIEW_MESSAGE_ACTION = {
  labelText: 'Delete',
  eventId: 'delete-view-message-action',
};

export const PRINT_VIEW_MESSAGE_ACTION = {
  labelText: 'Print message',
  eventId: 'print-view-message-action',
};

export const PREVIEW_VIEW_MESSAGE__ACTION = {
  labelText: 'Preview message',
  eventId: 'preview-view-message-action',
};
